function Reporting() {
    return (
        <div>Reporting Component</div>
    )
}
export default Reporting;